module.exports = __webpack_public_path__ + "assets/img/search-thick-white.90a7b197.svg";